export class IntercomHelper {
    public static moveLeft() : void {
        let elements = this.getElements();
        elements.forEach((el) => {
            el.classList.add("intercom-right");
        });
    };
    
    public static moveRight() : void {
        let elements = this.getElements();
        elements.forEach((el) => {
            el.classList.remove("intercom-right");
        });
    };
    
    private static getElements(): Array<any> {
        let element1: any = document.getElementsByClassName("intercom-lightweight-app-launcher intercom-launcher");
        let element2: any = document.getElementsByName("intercom-launcher-frame");
        
        let result: Array<any> = [];
        
        if(element1.length > 0)
            result.push(element1[0]);

        if(element2.length > 0)
            result.push(element2[0]);
        
        return result;
    };
}


// WEBPACK FOOTER //
// ./ClientApp/services/common/intercom-helper.ts